import RenderIf from "common/components/RenderIf";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import usePromotions from "common/datahooks/usePromotions";

import AgencySubscriptionCard from "../AgencySubscriptionCard";
import { LinkedInCrm, Rented } from "./SubscriptionCards";

export default function Billing() {
  const { agencyPlan } = usePromotions();
  const { subscription_status } = useSelectedWorkspaceContext();

  return (
    <>
      <RenderIf condition={agencyPlan && subscription_status !== "active"}>
        <AgencySubscriptionCard isAgencyPage={false} />
      </RenderIf>
      <RenderIf
        condition={
          !agencyPlan ||
          //if the user has no outreach subscription, subscription_status is null
          (subscription_status && subscription_status !== "cancelled")
        }
      >
        <LinkedInCrm />
      </RenderIf>
      <Rented />
    </>
  );
}
